export type TemplatePagePartialModel = {
  id: number,
  brand_id: number,
  designer_id: number,
  designer_type: string,
  height: number,
  hidden: boolean,
  measurement_unit: string,
  provider_id: number,
  short_name: string,
  title: string,
  width: number,
}

export type TemplatePagePartialRequestOptions = {}

const state = {
  id: undefined,
  brand_id: undefined,
  designer_id: undefined,
  designer_type: '',
  height: null,
  hidden: false,
  measurement_unit: '',
  provider_id: undefined,
  short_name: '',
  title: '',
  width: null,
}

export const requiredFields = [
  { key: 'designer_id' },
  { key: 'designer_type' },
  { key: 'brand_id' },
  { key: 'title' },
  { key: 'short_name' },
  { key: 'width' },
  { key: 'height' },
]

export default state
